import mergeWith from 'lodash/mergeWith';

/*
 * Actions
 */
const PREFIX = 'ENTITIES';

export const UPDATE_ENTITIES = `${PREFIX}/UPDATE_ENTITIES`;

export const DELETE_ENTITY_ITEMS = `${PREFIX}/DELETE_ENTITY_ITEMS`;

export const RESET_GENERIC_COURSE_RELATIVE_ENTITIES = `${PREFIX}/RESET_GENERIC_COURSE_RELATIVE_ENTITIES`;

export const RESET_ENTITY = `${PREFIX}/RESET_ENTITY`;

export const RESET_ENTITIES_ASSIGNMENTS = `${PREFIX}/RESET_ENTITIES_ASSIGNMENTS`;

/*
 *  Action creators
 */

export const resetGenericCourseRelativeEntities = () => ({
  type: RESET_GENERIC_COURSE_RELATIVE_ENTITIES
});

export const resetEntitiesAssignments = () => ({
  type: RESET_ENTITIES_ASSIGNMENTS
});

/*
 * This action creator is handle the async data from backend and normalized by the normalizr
 * It will flat the nesting data structure to the same level
 */
export const updateEntities = payload => ({
  type: UPDATE_ENTITIES,
  entities: { ...payload.entities }
});

export const deleteEntityItems = ({ entityName, itemIds }) => ({
  type: DELETE_ENTITY_ITEMS,
  entityName,
  itemIds
});

export const resetEntity = ({ entityName }) => ({
  type: RESET_ENTITY,
  entityName
});

const mergeEntities = (state, entities = {}) => {
  const updatedState = {
    ...state
  };

  Object.keys(entities).forEach(key => {
    updatedState[key] = {
      ...mergeWith(updatedState[key], entities[key], (objValue, srcValue) => {
        // Do not merge array created by normalizr schema
        if (Array.isArray(srcValue)) return srcValue;
        return undefined;
      })
    };
  });

  return updatedState;
};

/*
 * Reducer
 */
export const initialState = {
  assignments: {},
  classrooms: {},
  courses: {},
  groups: {},
  learningJourneySteps: {},
  learningJourneys: {},
  lockedCourseVersions: {},
  publications: {},
  standards: {},
  strands: {},
  students: {}
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ENTITIES: {
      return mergeEntities(state, action.entities);
    }

    case RESET_GENERIC_COURSE_RELATIVE_ENTITIES: {
      return {
        ...state,
        assignments: {},
        learningJourneySteps: {},
        learningJourneys: {},
        standards: {},
        strands: {}
      };
    }

    case RESET_ENTITIES_ASSIGNMENTS: {
      return {
        ...state,
        assignments: {}
      };
    }

    case DELETE_ENTITY_ITEMS: {
      const { entityName, itemIds } = action;
      const updatedEntity = {
        ...state[entityName]
      };

      itemIds.forEach(id => delete updatedEntity[id]);

      return {
        ...state,
        [entityName]: updatedEntity
      };
    }

    case RESET_ENTITY: {
      const { entityName } = action;

      const updatedState = state[entityName] ? { ...state, [entityName]: {} } : state;

      return updatedState;
    }

    default:
      break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./containers/entities/entities-reducer.js